import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { EmployeeService } from '../services/employee.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeeChangesGuard implements CanDeactivate<unknown> {
  constructor(private employeeService: EmployeeService){}
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (this.employeeService.isDirtyChanges()){
        return confirm('שינויים שבוצעו לא נשמרו.\nבטוח שברצונך לצאת?')
      }
    return true;
  }
  
}
